"use client";
export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <main className="mx-auto max-w-2xl px-5 py-24"><h1 className="font-prociono text-4xl">This page couldn’t load.</h1><p className="my-6">Please try again in a moment.</p><button onClick={reset} className="rounded-full bg-[#2B1B1C] px-6 py-3 text-white">Try again</button></main>;
}
